import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const SubscriptionDataSlice = createSlice({
    name: "Subscription",
    initialState,
    reducers: {
        getSubscriptionRequest(state) {
            state.loading = true;
        },
        getSubscriptionRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getSubscriptionRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getSubscriptionRequest,
    getSubscriptionRequestSuccess,
    getSubscriptionRequestError,
} = SubscriptionDataSlice.actions;

export default SubscriptionDataSlice.reducer;
